import React from "react";
import { UNABLE_TO_LOAD_FIELDS_CONTACT_CONTACT_ADMIN } from "../../configurations/MessageConstants";

export default function CheckGeoJson() {
  return (
    <div className="check-geojson">
      <b>{UNABLE_TO_LOAD_FIELDS_CONTACT_CONTACT_ADMIN}</b>
    </div>
  );
}
